import gql from 'graphql-tag';

export const UPDATE_ARTICLES_RUN_STATUS_MUTATION = gql`
  mutation UpdateArticlesRunStatusMutation($ids: [ID!]!, $runStatus: ArticleRunStatusEnum!) {
    updateArticlesRunStatus(ids: $ids, runStatus: $runStatus) {
      articles {
        id
        runStatus
      }
      errors
    }
  }
`;
